import { nativeEnum, object } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { ExternalAwardProvider } from '@occc/graphql';

export const AwardExternalSchema = object({
  provider: nativeEnum(ExternalAwardProvider, { required_error: IS_REQUIRED }),
});
